import React from "react";
import "./CustomerDetailModal.css";

const CustomerDetailModal = ({ isOpen, onClose, details }) => {
  if (!isOpen || !details) {
    return null;
  }

  const {
    username,
    ip_login = [],
    claimed_streaks_by_event = [],
    checkin_history = [],
  } = details;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{username}</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <h4>Lịch sử nhận thưởng sự kiện</h4>
          {claimed_streaks_by_event.length > 0 ? (
            claimed_streaks_by_event.map((event, eventIndex) => (
              <div key={eventIndex} className="event-container">
                <h5>
                  Sự kiện: {new Date(event.event_start).toLocaleDateString()} -{" "}
                  {new Date(event.event_end).toLocaleDateString()}
                </h5>
                <div className="ip-table-container">
                  <table className="ip-login-table">
                    <thead>
                      <tr>
                        <th>Streaks</th>
                        <th>Giftcode</th>
                        <th>Point</th>
                        <th>Ngày nhận</th>
                      </tr>
                    </thead>
                    <tbody>
                      {event.details.length > 0 ? (
                        event.details.map((claim, claimIndex) => (
                          <tr key={claimIndex}>
                            <td>{claim.streaks}</td>
                            <td>{claim.giftcode}</td>
                            <td>{claim.point}</td>
                            <td>
                              {new Date(claim.claimed_at).toLocaleString()}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">Không có dữ liệu.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <p>Không có lịch sử nhận thưởng.</p>
          )}

          <hr />

          <h4>Lịch sử điểm danh</h4>
          {checkin_history.length > 0 ? (
            checkin_history.map((history, historyIndex) => (
              <div key={historyIndex} className="event-container">
                <h5>
                  Tháng {history.month}/{history.year}
                </h5>
                <div className="ip-table-container">
                  <table className="ip-login-table">
                    <thead>
                      <tr>
                        <th>Ngày</th>
                        <th>Giftcode</th>
                        <th>Point</th>
                        <th>Tổng nạp</th>
                        <th>Tổng cược</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.details.length > 0 ? (
                        history.details.map((checkin, checkinIndex) => (
                          <tr key={checkinIndex}>
                            <td>{checkin.day}</td>
                            <td>{checkin.giftcode}</td>
                            <td>{checkin.point}</td>
                            <td>{checkin.total_deposit}</td>
                            <td>{checkin.total_valid_bet}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3">Không có dữ liệu.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <p>Không có lịch sử điểm danh.</p>
          )}

          <hr />

          <h4>Lịch sử đăng nhập ( 5 lần gần nhất )</h4>
          <div className="ip-table-container">
            <table className="ip-login-table">
              <thead>
                <tr>
                  <th>Địa chỉ IP</th>
                  <th>Thời gian đăng nhập</th>
                </tr>
              </thead>
              <tbody>
                {ip_login.length > 0 ? (
                  ip_login.map((login, index) => (
                    <tr key={index}>
                      <td>{login.ip_address}</td>
                      <td>{new Date(login.timestamp).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">Không có dữ liệu đăng nhập.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetailModal;
